/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-29 16:20:31
 * @LastEditors: liuziwei
 * @Description: 列表页领券 banner
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view wx:if="{{isShowCoupon}}" class="coupon-banner-simplify">
    <!-- 券组件部分 -->
    <banner
      activityId="{{activityId}}"
      couponList="{{allCoupons}}"
      extraText="{{extraText}}"
      bind:clickExtra="clickExtra"
      bannerStyle="{{bannerStyle}}"
    />
    <!-- 浮层部分 -->
    <drawer-frame
      title="优惠"
      leftTitle="{{true}}"
      open="{{openDrawer}}"
      customStyle="{{drawerCusStyle}}"
      bind:closeDrawer="closeDrawer"
    >
      <view slot="titleSlot" class="explain" bindtap="clickCouponRules">规则说明</view>
      <!-- 券列表部分 -->
      <coupon-list
        received="{{received}}"
        unclaimed="{{unclaimed}}"
        bannerFrom="{{bannerFrom}}"
      />
    </drawer-frame>
  </view>
</template>

<script>
  import store from '@/store'
  import { bannerFromConf } from '@/config/coupon'
  import { createComponent } from '@didi/es-mpx-creator'
  import { debounce } from '@/utils'
  import { goTo } from '@didi/webx-js'

  createComponent({
    data: {
      // drawer 展开状态
      openDrawer: false,
      bannerFromConf
    },
    props: {
      isShowNoticeTip: {
        type: Boolean,
        value: () => false
      },
      from: String
    },
    attached() {
      // 获取券列表数据
      this.getCouponData()
    },
    computed: {
      ...store.mapState({
        couponData: 'coupon.couponData'
      }),
      // 已领取的券
      received() {
        return this.couponData?.stock_coupons_info ?? []
      },
      // pope 活动 id
      activityId() {
        return this.couponData?.activity_id ?? ''
      },
      newCustomer() {
        return this.couponData?.new_customer ?? false
      },
      bannerFrom() {
        return this.from === 'makeOrder' ? bannerFromConf.makeOrder : bannerFromConf.tickets
      },
      // 未领取的券
      unclaimed() {
        // 未领取 + 活动券
        const coupon = this.couponData?.coupons_info.concat(this.couponData?.cyber_set_coupons)
        return coupon ?? []
      },
      bannerCoupon() {
        return this.couponData?.banner_coupons?.filter(item=> item && item.coupon_type !== 'accelerate_package') ?? []
      },
      // 服务端去重排好序的全部券数组
      allCoupons() {
        const coupon = this.couponData?.cyber_set_coupons?.length
          ? this.couponData?.cyber_set_coupons.concat(this.bannerCoupon)
          : this.bannerCoupon
        return coupon ?? []
      },
      // 是否展示优惠券
      isShowCoupon() {
        // 从下单页面进入优惠券页面的根据是否是新用户来判断是否展示
        if (this.from === 'makeOrder') {
          return this.couponData?.new_customer
        }
        return this.isShowNoticeTip ? this.hasRestCoupon : this.allCoupons.length
      },
      // 是否存在未领取的优惠券
      hasRestCoupon() {
        return this.unclaimed.length
      },
      // extra 文案
      extraText() {
        return this.couponData?.new_customer ? '去查看' : (this.hasRestCoupon ? '未领取' : '已领取')
      },
      // 自定义 drawer 样式
      drawerCusStyle() {
        return { minHeight: '400px', maxHeight: '70vh' }
      },
      bannerIcon() {
        return this.couponData?.new_customer ? 'https://ut-static.udache.com/webx/sfc/Oa1bIJDxl0CwJO6fpasSB.png': 'https://ut-static.udache.com/webx/sfc/PbLE806mfrMfRJ2XplCZA_didibutie.png'
      },
      bannerStyle() {
        const isNewCustomer = this.couponData?.new_customer
        const bannerStyle = {}
        if (isNewCustomer) {
          bannerStyle.back = { background: `url('https://ut-static.udache.com/webx/sfc/8bc5tGLcBsB9126tFQBA4.png')`, backgroundSize: '100%' }
        }
        bannerStyle.icon = isNewCustomer ? 'https://ut-static.udache.com/webx/sfc/Oa1bIJDxl0CwJO6fpasSB.png': 'https://ut-static.udache.com/webx/sfc/PbLE806mfrMfRJ2XplCZA_didibutie.png'
        return bannerStyle
      }
    },
    methods: {
      ...store.mapActions({
        getCouponData: 'coupon.getCouponData'
      }),
      // 关闭 drawer
      closeDrawer({ type }) {
        if (type === 'closeDrawer') this.openDrawer = false
      },
      // 点击 extra 区域的回调
      clickExtra({ type }) {
        // 点击 extra
        if (type === 'clickExtra') this.openDrawer = true
      },
      clickCouponRules: debounce(
        function () {
          goTo({ url: 'https://v.didi.cn/YgRZxDK' })
        },
        300,
        false
      ),
    }
  })
</script>

<style lang='stylus' scoped>
  .coupon-banner-simplify
    padding-top 12px
  .explain
    font-size 14px
    color #F86316
    font-weight 500
    margin-left 6px
    position relative
    &::after
      content ''
      top 9px
      right -8px
      position absolute
      width 4px
      height 4px
      border-top 1.5px solid
      border-right 1.5px solid
      transform rotate(45deg)
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      banner: './banner',
      'coupon-list': '../coupon-list',
      'drawer-frame': '../drawer-frame'
    }
  }
</script>
